import '@adornis/address/db/index.js';
import '@adornis/bh-timeframes/entities/Timeframe.js';
import '@adornis/data-view/db/export-data-view.js';
import '@adornis/file-utils/db/index.js';
import '@adornis/filter/filter-options.js';
import '@adornis/translation/db/index.js';
import '@adornis/users/db/index.js';
import '../enums/roles.js';
import '../logs/SuspensionLog.js';
import '../translations/translation.js';
import '../use-case-entities/EinzelberatungDataview.js';
import '../use-case-entities/ParticipationsDataview.js';
import '../use-case-entities/UserDataview.js';
import '../use-case-entities/export-participations.js';
import './BHPayment.js';
import './Bundle.js';
import './BundlePrice.js';
import './DynamicAdornisRoleToContextsWrapper.js';
import './LecturerContract.js';
import './Participation.js';
import './ParticipationEinzelberatung.js';
import './ParticipationExportCSV.js';
import './RegistrationConfirmationCode.js';
import './RegistrationDataBuffer.js';
import './action.js';
import './appointment.js';
import './category.js';
import './certificate.js';
import './default-enums.js';
import './einzelberatung.js';
import './global-setting.js';
import './institution.js';
import './lecturerComments.js';
import './lecturerData.js';
import './mail-templates.js';
import './products.js';
import './scalars.js';
import './stammdaten.js';
import './suspension.js';
import './teaching.js';
import './user.js';
import './workshop.js';

// plugins
import '../plugins/payment/BHDemoOrderNr.js';
import '../plugins/payment/BHIKHOrderNr.js';
import '../plugins/payment/BHSDOrderNr.js';
